/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Virtual Job Experience
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default [
  {
    url: '/student/dashboard',
    name: 'Home',
    slug: 'home',
    iconType: 'svgSprite',
    icon: 'home',
  },
  {
    header: 'Pre Work Experience',
    items: [
      {
        url: '/student/workplace-safety',
        name: 'Workplace Safety',
        icon: 'Workplace_Safety',
        iconType: 'svgSprite',
        slug: 'workplace_safety',
      },
      {
        url: '/student/workplace-preparation',
        name: 'Workplace Preparation',
        tagColor: 'primary',
        icon: 'Workplace_Preparation',
        iconType: 'svgSprite',
        slug: 'workplace_preparation',
      },
      {
        url: '/student/apply',
        name: 'Apply for a Position',
        tagColor: 'primary',
        icon: 'Apply_For_A_Position',
        iconType: 'svgSprite',
        slug: 'application',
      },
    ],
  },
  {
    header: 'Virtual Work Experience',
    items: [
      {
        url: '/student/available-experiences',
        name: 'Start a Virtual Experience',
        icon: 'Start_Experience',
        iconType: 'svgSprite',
        slug: 'work_experience',
      },
      {
        url: '/student/experiences/continue',
        name: 'Continue a Virtual Experience',
        icon: 'Continue_Virtual_Experience',
        iconType: 'svgSprite',
        slug: 'work_experience',
      },
      {
        url: '/student/experiences/completed',
        name: 'Completed Virtual Experience',
        icon: 'Completed_Experiences',
        iconType: 'svgSprite',
        slug: 'work_experience_real',
      },
    ],
  },

  {
    header: 'In-Person Work Experience',
    items: [
      {
        url: '/student/real-world-experience',
        name: 'Add Experience',
        icon: 'Add_Experience',
        iconType: 'svgSprite',
        slug: 'real-world-experience',
      },
    ],
  },
  {
    header: 'Post Work Experience',
    items: [
      {
        url: '/student/reflection/in-person',
        name: 'Reflection',
        icon: '065-happiness',
        iconType: 'svgSprite',
        slug: 'reflection',
      },
      {
        url: '/student/thank-you-letter',
        name: 'Thank you Letter',
        icon: 'heart',
        iconType: 'svgSprite',
        slug: 'thankyou_letter',
      },
      {
        url: '/student/certificates',
        name: 'Certificates',
        icon: 'certificates',
        iconType: 'svgSprite',
        slug: 'certificates',
      },
    ],
  },
  {
    header: ' ',
    items: [
      {
        name: 'Help',
        icon: 'HelpCircleIcon',
        url: '/student/help',
      },
      {
        name: 'Log Out',
        url: '/student/logout',
        icon: 'LogOutIcon',
      },
    ],
  },
];
